import ProductImageCard from './ProductImageCard';

export default ProductImageCard;
